var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"bg-cover",staticStyle:{"background-image":"url(/images/banner-bg.jpg)"}},[_c('div',{staticClass:"container py-12"},[_c('h1',{staticClass:"text-4xl uppercase font-light"},[_vm._v(_vm._s(_vm.page.title))])])]),_vm._v(" "),_c('div',{staticClass:"container mb-6"},[_c('Breadcrumbs',{staticClass:"my-6",attrs:{"breadcrumbs":[
            {label: 'Home', href: '/'},
            {label: _vm.page.title, href: null},
        ]}}),_vm._v(" "),_c('div',{staticClass:"prose max-w-none",domProps:{"innerHTML":_vm._s(_vm.page.body)}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }